var FooterTypes;
(function (FooterTypes) {
    FooterTypes["CAPTION"] = "caption";
    FooterTypes["LINK"] = "link";
    FooterTypes["NAVIGATION"] = "navigation";
    FooterTypes["BUTTON"] = "button";
})(FooterTypes || (FooterTypes = {}));
var ContentAspect;
(function (ContentAspect) {
    ContentAspect["INSIDE"] = "inside";
    ContentAspect["OUTSIDE"] = "outside";
})(ContentAspect || (ContentAspect = {}));

export { ContentAspect, FooterTypes };
//# sourceMappingURL=types.js.map
